var config = {};
config.env = 'int';

//AWS
config.aws = {};
config.aws.apiRoot = "https://int-api-gims.amgen.com/";

//SSO
config.sso = {};
config.sso.url = "https://dev-630954.okta.com/home/selfdev630954_demookta_2/0oa1ihwzcwpC2mKfu357/aln1iiaocr7jdzWe1357";

//api-key
config.api = {};
config.api.key = 'ukixP21J045VMtV2i0Gmv6TQOzEYwpkm8JwBjwRe';

export default config;
